/*
 *   Copyright (c) 2021 RCUBE PLANET PVT LTD
 *   All rights reserved.
 */
import React from 'react'
import * as Icon from 'react-feather'

const navigationConfig = [
  {
    id: 'home',
    title: 'Dashboard',
    type: 'item',
    icon: <Icon.Home size={20} />,
    navLink: '/',
  },
  {
    id: 'order',
    title: 'Orders',
    type: 'item',
    icon: <Icon.Package size={20} />,
    navLink: '/admin/order/list',
  },
  {
    id: 'Payments',
    title: 'Payments',
    type: 'item',
    icon: <Icon.DollarSign size={20} />,
    navLink: '/admin/payment/list',
  },
  {
    id: 'user',
    title: 'Users',
    type: 'collapse',
    icon: <Icon.User size={20} />,

    children: [
      {
        id: 'userList',
        title: 'View Users ',
        type: 'item',
        icon: <Icon.Circle size={10} />,
        navLink: '/admin/user/list',
        permissions: ['admin'],
      },

      // {
      //   id: 'kycList',
      //   title: 'Users KYC',
      //   type: 'item',
      //   icon: <Icon.Circle size={10} />,
      //   navLink: '/admin/user/kyc/list',
      //   permissions: ['admin'],
      // },
      // {
      //   id: 'fullTicketList',
      //   title: 'KYC Docs Ticket',
      //   type: 'item',
      //   icon: <Icon.Circle size={10} />,
      //   navLink: '/admin/user/kyc/full-ticket/list',
      //   permissions: ['admin'],
      // },
    ],
  },
  // {
  //   id: 'RechargeReport',
  //   title: 'Recharge Report ',
  //   type: 'item',
  //   icon: <Icon.FileText size={20} />,
  //   navLink: '/admin/failed/recharge/report',
  // },
  // {
  //   id: 'Operator Management',
  //   title: 'Operator Manager ',
  //   type: 'item',
  //   icon: <Icon.Settings size={20} />,
  //   navLink: '/admin/ads/google/campaign/list',
  // },

  {
    id: 'voucher',
    title: 'Voucher',
    type: 'item',
    icon: <Icon.Gift size={20} />,
    navLink: '/admin/wallet/voucher/list',
    permissions: ['admin'],
  },

  {
    id: 'static',
    title: 'Static Data',
    type: 'collapse',
    icon: <Icon.User size={20} />,

    children: [
      {
        id: 'visa',
        title: 'Visa List',
        type: 'item',
        icon: <Icon.Gift size={20} />,
        navLink: '/admin/static-data/visa/list',
        permissions: ['admin'],
      },
      {
        id: 'country-holiday',
        title: 'Country Holiday List',
        type: 'item',
        icon: <Icon.Gift size={20} />,
        navLink: '/admin/static-data/country-holiday/list',
        permissions: ['admin'],
      },
    ],
  },
  // {
  //   id: 'operator',
  //   title: 'Operators',
  //   type: 'item',
  //   icon: <Icon.BarChart size={20} />,
  //   navLink: '/admin/static-data/operator/list',
  // },
  {
    id: 'staff',
    title: 'Staff',
    type: 'item',
    icon: <Icon.Users size={20} />,
    navLink: '/admin/staff/list',
    permissions: ['admin', 'editor'],
  },
  // {
  //   id: 'Finance',
  //   title: 'Finance Report ',
  //   type: 'item',
  //   icon: <Icon.DollarSign size={20} />,
  //   navLink: '/admin/finance/report',
  // },
  {
    id: 'logout',
    title: 'Log Out',
    type: 'item',
    icon: <Icon.LogOut size={20} />,
    navLink: '/logout',
  },
]

export default navigationConfig
